module.exports = __webpack_public_path__ + "img/organizations_white.4a8fe548.svg";